import { Component } from "react";
import { Link } from "react-router-dom";
import cx from "classnames";

import ExternalLink from "./ExternalLink";

const popoverLabelClasses =
  "block p-[14px] cursor-pointer border-b border-gray-200 text-gray-800 text-sm lg:text-base leading-none font-normal transition-colors duration-200 select-none hover:text-hex-337ab7 focus-visible:outline-none focus-visible:bg-[#f5f8f9]";

export default class PopoverItem extends Component {
  render() {
    const { className, label, href, linkTo, onClick } = this.props;

    return (
      <li className={cx("[&:last-child>*]:border-b-0", className)}>
        {onClick ? (
          <span
            role="button"
            tabIndex={0}
            className={popoverLabelClasses}
            onClick={onClick}
            onKeyDown={e => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                onClick(e);
              }
            }}
          >
            {label}
          </span>
        ) : linkTo ? (
          <Link className={popoverLabelClasses} to={linkTo}>
            {label}
          </Link>
        ) : (
          <ExternalLink
            className={popoverLabelClasses}
            href={href}
          >
            {label}
          </ExternalLink>
        )}
      </li>
    );
  }
}
